import { useLazyQuery } from "@apollo/client/react";
import { Fragment, useEffect, useState } from "react";
import { CustomChip } from "../../../components/chip/Chip";
import { Box, Grid, CardContent, Card } from '@mui/material';
import PropTypes from 'prop-types';
import moment from 'moment';

import { GET_DERIVACION_PRESCRIPTOR_ADJUNTO } from "../../../data/graphQL/queries/ResumenIngresoValidation/getDerivacionPrescriptor";
import { AttachedFile } from "../../../components/attachedFile/AttachedFile";

const programasACambiar = [
  { id: 4, displayName: 'SI' },
  { id: 10, displayName: 'SIP' }];


export const InfoControl = ({ notification, tipoNotificacion }) => {
  const [notificationData, setNotificationData] = useState(notification || {});
  const [derivacionPrescriptor, setDerivacionPrescriptor] = useState(null);

  const [getDerivacionPrescriptor, { data: dataDerivacion }] = useLazyQuery(GET_DERIVACION_PRESCRIPTOR_ADJUNTO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDerivacion?.evaluacionById?.derivacionPrescriptor) return;

    setDerivacionPrescriptor({ ...dataDerivacion?.evaluacionById?.derivacionPrescriptor, titulo: 'RP' });
  }, [dataDerivacion]);

  useEffect(() => {
    if (!notificationData.idEvaluacion) return;
    getDerivacionPrescriptor({
      variables: {
        idEvaluacion: notificationData.idEvaluacion
      }
    });
  }, [notificationData.idEvaluacion]);

  function ItemR(props) {
    const { sx, ...other } = props;
    return (
      <Box
        sx={{
          bgcolor: (theme) => theme.palette.mode === 'dark' ? '#101010' : '#fff',
          color: (theme) => theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
          borderRadius: 0,
          fontSize: '0.75rem',
          ...sx,
          padding: 1
        }}
        {...other} />);


  }

  ItemR.propTypes = {
    sx: PropTypes.oneOfType([
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
      ),
      PropTypes.func,
      PropTypes.object]
    )
  };

  const [colorEstadosChip] = useState({
    'Pendiente': { isYellow: true },
    'Aprobado': { isGreen: true },
    'Rechazado': { isRed: true }
  });

  const [colorEstadoVAChip] = useState({
    'Pendiente': { isYellow: true },
    'Validado': { isGreen: true },
    'Sin RI': { isGray: true }
  });

  const getValue = (input) => {
    if (input.name.includes('fecha') && !!notificationData[input.name]) {
      return input.name === 'fechaNacimiento' ?
        moment(notificationData[input.name]).format('DD/MM/yyyy') :

        moment(notificationData[input.name]).format('DD/MM/yyyy HH:mm');
    }

    if (input.name === 'estadoRI') {
      const color = colorEstadosChip[notificationData[input.name]];

      return color ? <CustomChip label={notificationData[input.name]} {...color} /> :
        <div className='center'>-</div>;
    }

    if (input.name === 'estadoValidacion') {
      const color = colorEstadoVAChip[notificationData[input.name]];

      return color ? <CustomChip label={notificationData[input.name]} {...color} /> :
        <div className='center'>-</div>;
    }

    return notificationData[input.name] || '-';
  };

  return <>
    <div>
      <CustomChip
        isLightGray
        sx={{ paddingTop: '15px', paddingBottom: '15px', borderRadius: '5px' }}
        label={
          <>
            <span style={{ fontSize: 12, color: '#000' }}>
              Tipo de Notificación: <strong> {tipoNotificacion}</strong>
            </span>
          </>
        } />

      {!!notificationData?.idProgramaACambiar && <p>Solicitud cambio de programa: <strong>{programasACambiar.find((x) => x.id === notificationData?.idProgramaACambiar)?.displayName || '-'}</strong></p>}
    </div>
    <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
      <CardContent>
        <Grid container columns={100} columnSpacing={2} rowSpacing={1} size="grow">
          <Grid sx={{ paddingBottom: '10px' }} size={{ xs: 100, md: 100, lg: 100 }}><strong>Información del paciente</strong></Grid>
          {inputsCabeceraPaciente.map((input, index) => {
            const gridSize = { xs: 100, sm: 40, md: 23, lg: 23 };

            return (
              <Fragment key={`name-${input.name}-index${index}`}>
                <Grid sx={{ marginLeft: '10px' }} size={{ xs: gridSize.xs, sm: gridSize.sm, md: gridSize.md, lg: gridSize.lg }}>
                  <ItemR>
                    <strong>{input.displayName}</strong>
                  </ItemR>
                  <ItemR>
                    {getValue(input)}
                  </ItemR>
                </Grid>
              </Fragment>);

          })}
        </Grid>
      </CardContent>
    </Card>
    <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
      <CardContent>
        <Grid container columns={100} columnSpacing={2} rowSpacing={1} size="grow">
          <Grid sx={{ paddingBottom: '10px' }} size={{ xs: 100, md: 100, lg: 100 }}><strong>Información del contrato</strong></Grid>
          {inputsCabecera.map((input, index) => {
            const isSpecialInput = input.name === 'direccionRI' || input.name === 'observaciones' || input.name === 'observacionSolicitudCorreccion';
            const gridSize = isSpecialInput ? { xs: 100, sm: 100, md: 100, lg: 100 } : { xs: 100, sm: 40, md: 23, lg: 23 };

            return (
              <Fragment key={`name-${input.name}-index${index}`}>
                <Grid sx={{ marginLeft: '10px' }} size={{ xs: gridSize.xs, sm: gridSize.sm, md: gridSize.md, lg: gridSize.lg }}>
                  <ItemR>
                    <strong>{input.displayName}</strong>
                  </ItemR>
                  <ItemR>
                    {getValue(input)}
                  </ItemR>
                </Grid>
              </Fragment>);

          })}

          {derivacionPrescriptor &&
            <Grid sx={{ marginLeft: '10px' }} size={{ xs: 100 }}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <AttachedFile file={derivacionPrescriptor} type='base64' title='Ver RP' />
              </Box>
            </Grid>}
        </Grid>
      </CardContent>
    </Card>
  </>;
};

const inputsCabeceraPaciente = [
  {
    displayName: 'HC',
    name: 'hC'
  },
  {
    displayName: 'Paciente',
    name: 'paciente'
  },
  {
    displayName: 'DNI',
    name: 'numeroDocumento'
  },
  {
    displayName: 'Fecha de Nacimiento',
    name: 'fechaNacimiento'
  },
  {
    displayName: 'Edad',
    name: 'edad'
  },
  {
    displayName: 'Franja Etaria',
    name: 'franjaEtaria'
  },
  {
    displayName: 'Teléfono Paciente',
    name: 'telefonoContacto'
  },
  {
    displayName: 'Familiar a Cargo',
    name: 'familiar'
  },
  {
    displayName: 'Teléfono Familiar',
    name: 'familiarTelefono'
  }];


const inputsCabecera = [
  {
    displayName: 'Delegación',
    name: 'delegacion'
  },
  {
    displayName: 'Nro. Contrato',
    name: 'idEvaluacion'
  },
  {
    displayName: 'Tipo / Origen',
    name: 'tipoEvaluacion'
  },
  {
    displayName: 'Programa',
    name: 'programa'
  },
  {
    displayName: 'Cod SAP',
    name: 'codSap'
  },
  {
    displayName: 'Cliente',
    name: 'cliente'
  },
  {
    displayName: 'Estado Validación',
    name: 'estadoValidacion'
  },
  {
    displayName: 'Motivo Rechazo',
    name: 'motivoRechazo'
  },
  {
    displayName: 'Motivo No ingreso',
    name: 'motivoNoIngreso'
  },
  {
    displayName: 'Motivo Demora',
    name: 'motivoDemora'
  },
  {
    displayName: 'Profesional Asignado para RI',
    name: 'profesionalASignado'
  },
  {
    displayName: 'Fecha limite',
    name: 'fechaLimite'
  },
  {
    displayName: 'Fecha Realización',
    name: 'fechaRealizacion'
  },
  {
    displayName: 'Estado RI',
    name: 'estadoRI'
  },
  {
    displayName: 'Observaciones Asistenciales',
    name: 'observaciones'
  },
  {
    displayName: 'Direccion del RI',
    name: 'direccionRI'
  },
  {
    displayName: 'Motivo de solicitud de modificación',
    name: 'observacionSolicitudCorreccion'
  }];